import "./Book.module.css";
import Header from "@/reusable_sections/Header";
import SessionInquiry from "./sections/SessionInquiry";
import FindTheGarage from "./sections/FindTheGarage";
import Footer from "@/reusable_sections/Footer";
export default function BookPage() {
  return <div>
      <Header />
      <SessionInquiry />
      <FindTheGarage />
      <Footer />
    </div>;
}